// ContactActions
export const CONTACTS_LOADING = "CONTACTS_LOADING";
export const CONTACTS_LOADED = "CONTACTS_LOADED";
// MessageActions
export const MESSAGES_LOADING = "MESSAGES_LOADING";
export const MESSAGES_LOADED = "MESSAGES_LOADED";
export const MESSAGES_DELETED_ALERT = "MESSAGES_DELETED_ALERT";
export const MESSAGES_CLEAR_ALERT = "MESSAGES_CLEAR_ALERT";
// AccessibilityActions
export const TOGGLE_CONTRAST = "TOGGLE_CONTRAST";
// ConfigActions
export const CONFIG_DEBUG_ENABLE = "CONFIG_DEBUG_ENABLE";
export const CONFIG_SYSTEM_LOADING = "CONFIG_SYSTEM_LOADING";
export const CONFIG_SYSTEM_LOADED = "CONFIG_SYSTEM_LOADED";
export const CONFIG_INIT_COMPLETED = "CONFIG_INIT_COMPLETED";
export const CONFIG_REQUIREMEDIA_STARTED = "CONFIG_REQUIREMEDIA_STARTED";
export const CONFIG_REQUIREMEDIA_SUCCESS = "CONFIG_REQUIREMEDIA_SUCCESS";
export const CONFIG_REQUIREMEDIA_FAILURE = "CONFIG_REQUIREMEDIA_FAILURE";
export const CONFIG_SWITCHED_FREESWITCH = "CONFIG_SWITCHED_FREESWITCH";
export const WEBRTC_DETECTED = "WEBRTC_DETECTED";
export const LOCAL_IP_AQUIRED = "LOCAL_IP_AQUIRED";
export const BIND_LOCAL_STREAM = "BIND_LOCAL_STREAM";
export const UNBIND_LOCAL_STREAM = "UNBIND_LOCAL_STREAM";
// UserActions
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_REFRESH = "USER_REFRESH";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGIN_FAILED_TOKEN_INVALID =
  "USER_LOGIN_FAILED_TOKEN_INVALID";
export const USER_LOGIN_FAILED_TOKEN_EXPIRED =
  "USER_LOGIN_FAILED_TOKEN_EXPIRED";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCES";
export const USER_LOGINFORM_VALIDATE = "USER_LOGINFORM_VALIDATE";
// SipActions
export const SIP_REGISTER_SUCCESS = "SIP_REGISTER_SUCCESS";
export const SIP_CALLING = "SIP_CALLING";
export const SIP_CALL_REJECTED_REMOTE = "SIP_CALL_REJECTED_REMOTE";
export const SIP_CALL_ACCEPTED_REMOTE = "SIP_CALL_ACCEPTED_REMOTE";
export const SIP_CALL_COMPLETED = "SIP_CALL_COMPLETED";
export const SIP_CALL_TERMINATED_REMOTE = "SIP_CALL_TERMINATED_REMOTE";
export const SIP_CALL_TERMINATED_LOCAL = "SIP_CALL_TERMINATED_LOCAL";
export const SIP_REGISTER_STARTED = "SIP_REGISTER_STARTED";
export const SIP_CALL_CANCELED_REMOTE = "SIP_CALL_CANCELED_REMOTE";
export const SIP_CALL_FAILED = "SIP_CALL_FAILED";
export const SIP_CALL_FAILED_REMOTE = "SIP_CALL_FAILED_REMOTE";
export const SIP_INVITE_RECIEVED = "SIP_INVITE_RECIEVED";
export const SIP_REGISTER_FAILED = "SIP_REGISTER_FAILED";
export const SIP_UNREGISTERED = "SIP_UNREGISTERED";
export const SIP_CALL_ACCEPTED_LOCAL = "SIP_CALL_ACCEPTED_LOCAL";
export const SIP_CALL_SET_NEGOTIATED = "SIP_CALL_SET_NEGOTIATED";
export const SIP_ONLINE = "SIP_ONLINE";
export const SIP_MESSAGE_SENT = "SIP_MESSAGE_SENT";
export const SIP_WS_PING = "SIP_WS_PING";
export const SIP_CALL_REJECTED_LOCAL = "SIP_CALL_REJECTED_LOCAL";
export const SIP_CALL_CANCELED_LOCAL = "SIP_CALL_CANCELED_LOCAL";
export const SIP_UPDATEREGISTEREDENDPOINT_STARTED =
  "SIP_UPDATEREGISTEREDENDPOINT_STARTED";
export const SIP_UPDATEREGISTEREDENDPOINT_COMPLETED =
  "SIP_UPDATEREGISTEREDENDPOINT_COMPLETED";
export const SIP_UPDATEREGISTEREDENDPOINT_ERROR =
  "SIP_UPDATEREGISTEREDENDPOINT_ERROR";
export const SIP_UPDATE_OPTIONS = "SIP_UPDATE_OPTIONS";
export const SIP_LOGOUT = "SIP_LOGOUT";
// ErrorActions
export const NETWORK_ERROR_ALERT = "NETWORK_ERROR_ALERT";
export const NETWORK_CLEAR_ALERT = "NETWORK_CLEAR_ALERT";
export const SIP_ERROR_ALERT = "SIP_ERROR_ALERT";
export const SIP_CLEAR_ALERT = "SIP_CLEAR_ALERT";
// ContactActions
export const UPDATE_CONTACT_LOCALLY = "UPDATE_CONTACT_LOCALLY";
export const DELETE_CONTACT_LOCALLY = "DELETE_CONTACT_LOCALLY";
export const CONTACT_REMOVE_LOADING = "CONTACT_REMOVE_LOADING";
export const CONTACT_NO_SIP_GIVEN = "CONTACT_NO_SIP_GIVEN";
export const CONTACT_CLEAR_ALERT = "CONTACT_CLEAR_ALERT";
// SettingActions
export const SETTINGS_USER_LOADING = "SETTINGS_USER_LOADING";
export const SETTINGS_USER_LOADED = "SETTINGS_USER_LOADED";
export const SETTINGS_USER_LOADED_DEFAULT = "SETTINGS_USER_LOADED_DEFAULT";
export const SETTINGS_SAVE = "SETTINGS_SAVE";
// CallActions
export const CALL_TO_UNREGISTERED = "CALL_TO_UNREGISTERED";
export const CHANGE_VIEW = "CHANGE_VIEW";
export const CALL_ANSWER = "CALL_ANSWER";
export const CALL_CALL = "CALL_CALL";
export const CALL_HANGUP = "CALL_HANGUP";
export const CALL_DTMF = "CALL_DTMF";
export const CALL_REJECT = "CALL_REJECT";
export const CALL_TEXT_MSG_IN = "CALL_TEXT_MSG_IN";
export const CALL_TEXT_MSG_IN_CLEAR = "CALL_TEXT_MSG_IN_CLEAR";
export const CALL_TEXT_MSG_IN_DEL = "CALL_TEXT_MSG_IN_DEL";
export const CALL_TEXT_MSG_OUT = "CALL_TEXT_MSG_OUT";
export const CALL_TEXT_MSG_OUT_CLEAR = "CALL_TEXT_MSG_OUT_CLEAR";
export const CALL_TEXT_MSG_OUT_DEL = "CALL_TEXT_MSG_OUT_DEL";
export const CALL_MUTE_AUDIO = "CALL_MUTE_AUDIO";
export const CALL_MUTE_REMOTE_AUDIO = "CALL_MUTE_REMOTE_AUDIO";
export const CALL_MUTE_VIDEO = "CALL_MUTE_VIDEO";
export const CALL_HIDE_VIDEO = "CALL_HIDE_VIDEO";
export const CALL_HIDE_TEXT = "CALL_HIDE_TEXT";
export const CALL_HIDE_DIALER = "CALL_HIDE_DIALER";
export const CALL_HIDE_SELFVIEW = "CALL_HIDE_SELFVIEW";
export const CALL_SHOW_MORE = "CALL_SHOW_MORE";
export const CALL_TOGGLE_VIDEO_MODE = "CALL_TOGGLE_VIDEO_MODE";
export const CALL_KNOCK_KNOCK = "CALL_KNOCK_KNOCK";

export const UNSUPPORTED_BROWSER = "UNSUPPORTED_BROWSER";

export default {
  CONTACTS_LOADING,
  CONTACTS_LOADED,

  MESSAGES_LOADING,
  MESSAGES_LOADED,
  MESSAGES_DELETED_ALERT,
  MESSAGES_CLEAR_ALERT,

  TOGGLE_CONTRAST,
  CONFIG_DEBUG_ENABLE,
  CONFIG_SYSTEM_LOADING,
  CONFIG_SYSTEM_LOADED,
  CONFIG_INIT_COMPLETED,
  CONFIG_REQUIREMEDIA_STARTED,
  CONFIG_REQUIREMEDIA_SUCCESS,
  CONFIG_REQUIREMEDIA_FAILURE,
  CONFIG_SWITCHED_FREESWITCH,
  WEBRTC_DETECTED,
  USER_LOGIN_SUCCESS,
  USER_REFRESH,
  USER_LOGIN_FAILED,
  USER_LOGIN_FAILED_TOKEN_INVALID,
  USER_LOGIN_FAILED_TOKEN_EXPIRED,
  USER_LOGOUT_SUCCESS,
  USER_LOGINFORM_VALIDATE,

  SIP_REGISTER_SUCCESS,
  SIP_CALLING,
  SIP_CALL_REJECTED_REMOTE,
  SIP_CALL_ACCEPTED_REMOTE,
  SIP_CALL_COMPLETED,
  SIP_CALL_TERMINATED_REMOTE,
  SIP_CALL_TERMINATED_LOCAL,
  SIP_REGISTER_STARTED,
  SIP_CALL_CANCELED_REMOTE,
  SIP_CALL_FAILED,
  SIP_CALL_FAILED_REMOTE,
  SIP_INVITE_RECIEVED,
  SIP_REGISTER_FAILED,
  SIP_UNREGISTERED,
  SIP_CALL_ACCEPTED_LOCAL,
  SIP_CALL_SET_NEGOTIATED,
  SIP_ONLINE,
  SIP_MESSAGE_SENT,
  SIP_WS_PING,
  SIP_CALL_REJECTED_LOCAL,
  SIP_CALL_CANCELED_LOCAL,
  SIP_UPDATEREGISTEREDENDPOINT_STARTED,
  SIP_UPDATEREGISTEREDENDPOINT_COMPLETED,
  SIP_UPDATEREGISTEREDENDPOINT_ERROR,
  SIP_UPDATE_OPTIONS,
  SIP_LOGOUT,

  NETWORK_ERROR_ALERT,
  NETWORK_CLEAR_ALERT,
  SIP_ERROR_ALERT,
  SIP_CLEAR_ALERT,

  LOCAL_IP_AQUIRED,

  BIND_LOCAL_STREAM,
  UNBIND_LOCAL_STREAM,

  UPDATE_CONTACT_LOCALLY,
  DELETE_CONTACT_LOCALLY,
  CONTACT_REMOVE_LOADING,
  CONTACT_NO_SIP_GIVEN,
  CONTACT_CLEAR_ALERT,

  SETTINGS_USER_LOADING,
  SETTINGS_USER_LOADED,
  SETTINGS_USER_LOADED_DEFAULT,
  SETTINGS_SAVE,

  CALL_TO_UNREGISTERED,
  CHANGE_VIEW,
  CALL_ANSWER,
  CALL_CALL,
  CALL_HANGUP,
  CALL_DTMF,
  CALL_REJECT,
  CALL_TEXT_MSG_IN,
  CALL_TEXT_MSG_IN_CLEAR,
  CALL_TEXT_MSG_IN_DEL,
  CALL_TEXT_MSG_OUT,
  CALL_TEXT_MSG_OUT_CLEAR,
  CALL_TEXT_MSG_OUT_DEL,
  CALL_MUTE_AUDIO,
  CALL_MUTE_REMOTE_AUDIO,
  CALL_MUTE_VIDEO,
  CALL_HIDE_VIDEO,
  CALL_HIDE_TEXT,
  CALL_HIDE_DIALER,
  CALL_HIDE_SELFVIEW,
  CALL_SHOW_MORE,
  CALL_TOGGLE_VIDEO_MODE,
  CALL_KNOCK_KNOCK,

  UNSUPPORTED_BROWSER,
};






// WEBPACK FOOTER //
// ./src/actions/actionTypes.js